import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface ISupplierDetail {
    id: string,
    code: string,
    name: string,
    orgCode?: string,
    orgName?: string,
    shopId?: string,
    shopName?: string,
    level?: string,
    contact?: string,
    phone?: string,
    address?: string,
    status?: string,
    website?: string,
    tel?: string,
    fax?: string,
    licenseNo?: string,
    businessScope?: string,
    categoryCode?: string,
    categoryName?: string,
    note?: string,
    invoiceTitle?: string,
    bank?: string,
    bankAcct?: string,
    postAddress?: string,
    taxNo?: string,
    bankPhone?: string,
    corporation?: string,
    isInternal?: string,
    linkCode?: string,
    staffCode?: string,
    staffName?: string,
    attrCode?: string,
    attrName?: string,
    contractEndTime?:string;
    contractStartTime:string;
    qualifications?:string;
    createTime?:any;
	updateTime?:any;

}
//新增
export interface ISupplierInsert extends ISupplierDetail {

}

//编辑
export interface ISupplierUpdate extends ISupplierInsert {
    id: string,
}

//搜索条件
export interface ISupplierSearchFields {
    shopId?: string
    shopCode?: string
}

export interface ISupplierSearch
    extends ISupplierSearchFields, ISearchPage {

}


class SupplierService {
    async page(searchVo: ISupplierSearch, config: object = {}) {
        const apiUrl = "/gtm/base/supplier/listPage";
        return await httpRequest.post<IPage<ISupplierDetail>>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        const apiUrl = `/gtm/base/supplier/findById/${id}`;
        return await httpRequest.get<ISupplierDetail>(apiUrl);
    }
    async insert(insertVo: ISupplierInsert) {
        const apiUrl = "/gtm/base/supplier/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ISupplierUpdate) {
        const apiUrl = "/gtm/base/supplier/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id: string, status: number) {
        const apiUrl = `/gtm/base/supplier/enableOrDisable/${id}/${status}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/gtm/base/supplier/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: ISupplierSearch) {
        const appPageUrl = "/gtm/base/supplier/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/base/supplier/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

}

export const supplierService = new SupplierService();
